"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class ParentAlreadyExistsError extends client_library_1.ExtendableError {
    constructor() {
        super('Parent already exists');
    }
}
exports.default = ParentAlreadyExistsError;
//# sourceMappingURL=ParentAlreadyExistsError.js.map